import React from 'react';
import Proptypes from 'prop-types';

import {
  Paragraph,
  Icon,
  Block,
} from 'components/common';

import './MissionStatement.scss';

const CompareItem = ({ image, description, articleLink }) => (
  <div className="layout-column column-md-4 compare-item-wrapper">
    <div className="compare-item">
      <div className="image">
        <img src={image.url} alt={image.title} />
      </div>
      <div>
        <Paragraph>
          {description}
          &nbsp;
          {articleLink && (
            <a href={articleLink} rel="noopener noreferrer" target="_blank" className="link">
              <Icon name="question" />
            </a>
          )}
        </Paragraph>
      </div>
    </div>
  </div>
);

CompareItem.propTypes = {
  description: Proptypes.string.isRequired,
  image: Proptypes.shape({
    url: Proptypes.string,
    title: Proptypes.string,
  }).isRequired,
  articleLink: Proptypes.string,
};

CompareItem.defaultProps = {
  articleLink: null,
};

const MissionStatement = ({ section, heading }) => (
  <div className="compare-then-buy-wrapper">
    {section && (
      <Block>
        <Block.Header
          title={heading}
        />
        <div className="layout-container compare-then-buy">
          <div className="layout-row">
            {
              section.map((item, idx) => (
                // eslint-disable-next-line
                <CompareItem {...item} key={idx} />
              ))}
          </div>
        </div>
      </Block>
    )}
  </div>
);

export default MissionStatement;

MissionStatement.defaultProps = {
  section: null,
  heading: null,
};

MissionStatement.propTypes = {
  section: Proptypes.arrayOf(
    Proptypes.shape({
      description: Proptypes.string,
      image: Proptypes.shape({
        url: Proptypes.string,
        title: Proptypes.string,
      }),
      articleLink: Proptypes.string,
    }),
  ),
  heading: Proptypes.string,
};
